// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qD6LS","title":"styles_title__3Rn3Y"};